<template>
	<div class="flex items-center justify-center w-4 h-4 rounded-full bg-identity-50 dark:bg-identity-900">
		<span class="w-[10px] h-[10px] bg-identity-600 rounded-full relative">
			<span class="absolute w-full h-full duration-1000 rounded-full bg-identity-600 animate-ping" />
		</span>
	</div>
</template>
